import { useEffect, useState } from 'react';

// Recuerda la página y los filtros de un listado mientras la pestaña esté
// abierta, para que al volver de Editar / Ver (con "Guardar" o con "Volver")
// el listado quede donde estaba y no en la página 1.
//
// Se guardan juntos a propósito: la página 3 de una búsqueda filtrada no es la
// misma página 3 sin filtro.
//
// Uso en un listado:
//   const { filters, setFilters, currentPage, setCurrentPage, olvidar } =
//       useListadoRecordado('procedencias', { descripcion: '', cod: '' });
//   useEffect(() => { getAll(currentPage); }, []);   // carga inicial en la página recordada
//
// `olvidar()` vuelve a la página 1 sin filtros (para el botón de recargar).
//
// sessionStorage puede no estar disponible (modo privado, bloqueado): en ese
// caso el listado funciona igual, solo que no recuerda nada.

const PREFIJO = 'listado:';

const leer = (clave) => {
  try {
    const crudo = window.sessionStorage.getItem(PREFIJO + clave);
    return crudo ? JSON.parse(crudo) : null;
  } catch {
    return null;
  }
};

const escribir = (clave, valor) => {
  try {
    window.sessionStorage.setItem(PREFIJO + clave, JSON.stringify(valor));
  } catch {
    // Sin almacenamiento: no se recuerda, pero no se rompe nada.
  }
};

const borrar = (clave) => {
  try {
    window.sessionStorage.removeItem(PREFIJO + clave);
  } catch {
    // idem
  }
};

export const useListadoRecordado = (clave, filtrosIniciales = {}) => {
  const guardado = leer(clave);

  const [filters, setFilters] = useState(() =>
    // Se mezcla con los iniciales: si el listado agregó un filtro nuevo desde
    // la última vez, no queda undefined.
    guardado && guardado.filtros ? { ...filtrosIniciales, ...guardado.filtros } : filtrosIniciales
  );
  const [currentPage, setCurrentPage] = useState(() => {
    const p = Number(guardado && guardado.pagina);
    return Number.isInteger(p) && p > 0 ? p : 1;
  });

  useEffect(() => {
    escribir(clave, { filtros: filters, pagina: currentPage });
  }, [clave, filters, currentPage]);

  const olvidar = () => {
    borrar(clave);
    setFilters(filtrosIniciales);
    setCurrentPage(1);
  };

  return { filters, setFilters, currentPage, setCurrentPage, olvidar };
};

export default useListadoRecordado;
